export const sortContacts = (contacts) => {
    return contacts.sort((contactA, contactB) => {
        const hasUnreadA = contactA.countNotRead > 0;
        const hasUnreadB = contactB.countNotRead > 0;

        if (hasUnreadA && hasUnreadB) {
            return contactB.lastMessageDatetime - contactA.lastMessageDatetime;
        } else if (hasUnreadA) {
            return -1;
        } else if (hasUnreadB) {
            return 1;
        }

        if (contactA.lastMessageDatetime && contactB.lastMessageDatetime) {
            return contactB.lastMessageDatetime - contactA.lastMessageDatetime;
        } else if (contactA.lastMessageDatetime) {
            return -1;
        } else if (contactB.lastMessageDatetime) {
            return 1;
        }

        const isClientA = contactA.info?.client;
        const isClientB = contactB.info?.client;

        if (isClientA && isClientB) {
            return contactB.lastMessageDatetime - contactA.lastMessageDatetime;
        } else if (isClientA) {
            return -1;
        } else if (isClientB) {
            return 1;
        }

        const nameA = contactA.name.toLowerCase();
        const nameB = contactB.name.toLowerCase();
        return nameA.localeCompare(nameB);
    });
};
